import { render, staticRenderFns } from "./CallToAction.vue?vue&type=template&id=ffcb7578&scoped=true&"
var script = {}
import style0 from "./CallToAction.vue?vue&type=style&index=0&id=ffcb7578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcb7578",
  null
  
)

export default component.exports